import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { get, post, put, remove } from './lib/fetch';
import { COOKIE_OPTIONS } from './lib/constants';
import { setCookies, getCookieString } from './lib/cookies';
import { expiresAt, resolveFetch } from './lib/helpers';

var GoTrueApi = /*#__PURE__*/function () {
  function GoTrueApi(_ref) {
    var _ref$url = _ref.url,
        url = _ref$url === void 0 ? '' : _ref$url,
        _ref$headers = _ref.headers,
        headers = _ref$headers === void 0 ? {} : _ref$headers,
        cookieOptions = _ref.cookieOptions,
        fetch = _ref.fetch;

    _classCallCheck(this, GoTrueApi);

    this.url = url;
    this.headers = headers;
    this.cookieOptions = Object.assign(Object.assign({}, COOKIE_OPTIONS), cookieOptions);
    this.fetch = resolveFetch(fetch);
  }
  /**
   * Create a temporary object with all configured headers and
   * adds the Authorization token to be used on request methods
   * @param jwt A valid, logged-in JWT.
   */


  _createClass(GoTrueApi, [{
    key: "_createRequestHeaders",
    value: function _createRequestHeaders(jwt) {
      var headers = Object.assign({}, this.headers);
      headers['Authorization'] = "Bearer ".concat(jwt);
      return headers;
    }
  }, {
    key: "cookieName",
    value: function cookieName() {
      var _a;

      return (_a = this.cookieOptions.name) !== null && _a !== void 0 ? _a : '';
    }
    /**
     * Generates the relevant login URL for a third-party provider.
     * @param provider One of the providers supported by GoTrue.
     * @param redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param scopes A space-separated list of scopes granted to the OAuth application.
     */

  }, {
    key: "getUrlForProvider",
    value: function getUrlForProvider(provider, options) {
      var urlParams = ["provider=".concat(encodeURIComponent(provider))];

      if (options === null || options === void 0 ? void 0 : options.redirectTo) {
        urlParams.push("redirect_to=".concat(encodeURIComponent(options.redirectTo)));
      }

      if (options === null || options === void 0 ? void 0 : options.scopes) {
        urlParams.push("scopes=".concat(encodeURIComponent(options.scopes)));
      }

      if (options === null || options === void 0 ? void 0 : options.queryParams) {
        var query = new URLSearchParams(options.queryParams);
        urlParams.push("".concat(query));
      }

      return "".concat(this.url, "/authorize?").concat(urlParams.join('&'));
    }
    /**
     * Creates a new user using their email address.
     * @param email The email address of the user.
     * @param password The password of the user.
     * @param redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param data Optional user metadata.
     * @param captchaToken Verification token received when the user completes the captcha on your site.
     *
     * @returns A logged-in session if the server has "autoconfirm" ON
     * @returns A user if the server has "autoconfirm" OFF
     */

  }, {
    key: "signUpWithEmail",
    value: function signUpWithEmail(email, password) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var headers, queryString, data, session;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                headers = Object.assign({}, this.headers);
                queryString = '';

                if (options.redirectTo) {
                  queryString = '?redirect_to=' + encodeURIComponent(options.redirectTo);
                }

                _context.next = 6;
                return post(this.fetch, "".concat(this.url, "/signup").concat(queryString), {
                  email: email,
                  password: password,
                  data: options.data,
                  gotrue_meta_security: {
                    captcha_token: options.captchaToken
                  }
                }, {
                  headers: headers
                });

              case 6:
                data = _context.sent;
                session = Object.assign({}, data);
                if (session.expires_in) session.expires_at = expiresAt(data.expires_in);
                return _context.abrupt("return", {
                  data: session,
                  error: null
                });

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", {
                  data: null,
                  error: _context.t0
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 12]]);
      }));
    }
    /**
     * Logs in an existing user using their email address.
     * @param email The email address of the user.
     * @param password The password of the user.
     * @param redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param captchaToken Verification token received when the user completes the captcha on your site.
     */

  }, {
    key: "signInWithEmail",
    value: function signInWithEmail(email, password) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var headers, queryString, data, session;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                headers = Object.assign({}, this.headers);
                queryString = '?grant_type=password';

                if (options.redirectTo) {
                  queryString += '&redirect_to=' + encodeURIComponent(options.redirectTo);
                }

                _context2.next = 6;
                return post(this.fetch, "".concat(this.url, "/token").concat(queryString), {
                  email: email,
                  password: password,
                  gotrue_meta_security: {
                    captcha_token: options.captchaToken
                  }
                }, {
                  headers: headers
                });

              case 6:
                data = _context2.sent;
                session = Object.assign({}, data);
                if (session.expires_in) session.expires_at = expiresAt(data.expires_in);
                return _context2.abrupt("return", {
                  data: session,
                  error: null
                });

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", {
                  data: null,
                  error: _context2.t0
                });

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 12]]);
      }));
    }
    /**
     * Signs up a new user using their phone number and a password.
     * @param phone The phone number of the user.
     * @param password The password of the user.
     * @param data Optional user metadata.
     * @param captchaToken Verification token received when the user completes the captcha on your site.
     */

  }, {
    key: "signUpWithPhone",
    value: function signUpWithPhone(phone, password) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var headers, data, session;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                headers = Object.assign({}, this.headers);
                _context3.next = 4;
                return post(this.fetch, "".concat(this.url, "/signup"), {
                  phone: phone,
                  password: password,
                  data: options.data,
                  gotrue_meta_security: {
                    captcha_token: options.captchaToken
                  }
                }, {
                  headers: headers
                });

              case 4:
                data = _context3.sent;
                session = Object.assign({}, data);
                if (session.expires_in) session.expires_at = expiresAt(data.expires_in);
                return _context3.abrupt("return", {
                  data: session,
                  error: null
                });

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", {
                  data: null,
                  error: _context3.t0
                });

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 10]]);
      }));
    }
    /**
     * Logs in an existing user using their phone number and password.
     * @param phone The phone number of the user.
     * @param password The password of the user.
     * @param captchaToken Verification token received when the user completes the captcha on your site.
     */

  }, {
    key: "signInWithPhone",
    value: function signInWithPhone(phone, password) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var headers, queryString, data, session;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                headers = Object.assign({}, this.headers);
                queryString = '?grant_type=password';
                _context4.next = 5;
                return post(this.fetch, "".concat(this.url, "/token").concat(queryString), {
                  phone: phone,
                  password: password,
                  gotrue_meta_security: {
                    captcha_token: options.captchaToken
                  }
                }, {
                  headers: headers
                });

              case 5:
                data = _context4.sent;
                session = Object.assign({}, data);
                if (session.expires_in) session.expires_at = expiresAt(data.expires_in);
                return _context4.abrupt("return", {
                  data: session,
                  error: null
                });

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", {
                  data: null,
                  error: _context4.t0
                });

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 11]]);
      }));
    }
    /**
     * Logs in an OpenID Connect user using their id_token.
     * @param id_token The IDToken of the user.
     * @param nonce The nonce of the user. The nonce is a random value generated by the developer (= yourself) before the initial grant is started. You should check the OpenID Connect specification for details. https://openid.net/developers/specs/
     * @param provider The provider of the user.
     * @param client_id The clientID of the user.
     * @param issuer The issuer of the user.
     */

  }, {
    key: "signInWithOpenIDConnect",
    value: function signInWithOpenIDConnect(_ref2) {
      var id_token = _ref2.id_token,
          nonce = _ref2.nonce,
          client_id = _ref2.client_id,
          issuer = _ref2.issuer,
          provider = _ref2.provider;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var headers, queryString, data, session;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                headers = Object.assign({}, this.headers);
                queryString = '?grant_type=id_token';
                _context5.next = 5;
                return post(this.fetch, "".concat(this.url, "/token").concat(queryString), {
                  id_token: id_token,
                  nonce: nonce,
                  client_id: client_id,
                  issuer: issuer,
                  provider: provider
                }, {
                  headers: headers
                });

              case 5:
                data = _context5.sent;
                session = Object.assign({}, data);
                if (session.expires_in) session.expires_at = expiresAt(data.expires_in);
                return _context5.abrupt("return", {
                  data: session,
                  error: null
                });

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", {
                  data: null,
                  error: _context5.t0
                });

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 11]]);
      }));
    }
    /**
     * Sends a magic login link to an email address.
     * @param email The email address of the user.
     * @param shouldCreateUser A boolean flag to indicate whether to automatically create a user on magiclink / otp sign-ins if the user doesn't exist. Defaults to true.
     * @param redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param captchaToken Verification token received when the user completes the captcha on your site.
     */

  }, {
    key: "sendMagicLinkEmail",
    value: function sendMagicLinkEmail(email) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _a;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var headers, queryString, shouldCreateUser, data;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                headers = Object.assign({}, this.headers);
                queryString = '';

                if (options.redirectTo) {
                  queryString += '?redirect_to=' + encodeURIComponent(options.redirectTo);
                }

                shouldCreateUser = (_a = options.shouldCreateUser) !== null && _a !== void 0 ? _a : true;
                _context6.next = 7;
                return post(this.fetch, "".concat(this.url, "/otp").concat(queryString), {
                  email: email,
                  create_user: shouldCreateUser,
                  gotrue_meta_security: {
                    captcha_token: options.captchaToken
                  }
                }, {
                  headers: headers
                });

              case 7:
                data = _context6.sent;
                return _context6.abrupt("return", {
                  data: data,
                  error: null
                });

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", {
                  data: null,
                  error: _context6.t0
                });

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 11]]);
      }));
    }
    /**
     * Sends a mobile OTP via SMS. Will register the account if it doesn't already exist
     * @param phone The user's phone number WITH international prefix
     * @param shouldCreateUser A boolean flag to indicate whether to automatically create a user on magiclink / otp sign-ins if the user doesn't exist. Defaults to true.
     * @param captchaToken Verification token received when the user completes the captcha on your site.
     */

  }, {
    key: "sendMobileOTP",
    value: function sendMobileOTP(phone) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _a;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var shouldCreateUser, headers, data;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                shouldCreateUser = (_a = options.shouldCreateUser) !== null && _a !== void 0 ? _a : true;
                headers = Object.assign({}, this.headers);
                _context7.next = 5;
                return post(this.fetch, "".concat(this.url, "/otp"), {
                  phone: phone,
                  create_user: shouldCreateUser,
                  gotrue_meta_security: {
                    captcha_token: options.captchaToken
                  }
                }, {
                  headers: headers
                });

              case 5:
                data = _context7.sent;
                return _context7.abrupt("return", {
                  data: data,
                  error: null
                });

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7["catch"](0);
                return _context7.abrupt("return", {
                  data: null,
                  error: _context7.t0
                });

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 9]]);
      }));
    }
    /**
     * Removes a logged-in session.
     * @param jwt A valid, logged-in JWT.
     */

  }, {
    key: "signOut",
    value: function signOut(jwt) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return post(this.fetch, "".concat(this.url, "/logout"), {}, {
                  headers: this._createRequestHeaders(jwt),
                  noResolveJson: true
                });

              case 3:
                return _context8.abrupt("return", {
                  error: null
                });

              case 6:
                _context8.prev = 6;
                _context8.t0 = _context8["catch"](0);
                return _context8.abrupt("return", {
                  error: _context8.t0
                });

              case 9:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 6]]);
      }));
    }
    /**
     * @deprecated Use `verifyOTP` instead!
     * @param phone The user's phone number WITH international prefix
     * @param token token that user was sent to their mobile phone
     * @param redirectTo A URL or mobile address to send the user to after they are confirmed.
     */

  }, {
    key: "verifyMobileOTP",
    value: function verifyMobileOTP(phone, token) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var headers, data, session;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                headers = Object.assign({}, this.headers);
                _context9.next = 4;
                return post(this.fetch, "".concat(this.url, "/verify"), {
                  phone: phone,
                  token: token,
                  type: 'sms',
                  redirect_to: options.redirectTo
                }, {
                  headers: headers
                });

              case 4:
                data = _context9.sent;
                session = Object.assign({}, data);
                if (session.expires_in) session.expires_at = expiresAt(data.expires_in);
                return _context9.abrupt("return", {
                  data: session,
                  error: null
                });

              case 10:
                _context9.prev = 10;
                _context9.t0 = _context9["catch"](0);
                return _context9.abrupt("return", {
                  data: null,
                  error: _context9.t0
                });

              case 13:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 10]]);
      }));
    }
    /**
     * Send User supplied Email / Mobile OTP to be verified
     * @param email The user's email address
     * @param phone The user's phone number WITH international prefix
     * @param token token that user was sent to their mobile phone
     * @param type verification type that the otp is generated for
     * @param redirectTo A URL or mobile address to send the user to after they are confirmed.
     */

  }, {
    key: "verifyOTP",
    value: function verifyOTP(_ref3) {
      var email = _ref3.email,
          phone = _ref3.phone,
          token = _ref3.token,
          _ref3$type = _ref3.type,
          type = _ref3$type === void 0 ? 'sms' : _ref3$type;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var headers, data, session;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                headers = Object.assign({}, this.headers);
                _context10.next = 4;
                return post(this.fetch, "".concat(this.url, "/verify"), {
                  email: email,
                  phone: phone,
                  token: token,
                  type: type,
                  redirect_to: options.redirectTo
                }, {
                  headers: headers
                });

              case 4:
                data = _context10.sent;
                session = Object.assign({}, data);
                if (session.expires_in) session.expires_at = expiresAt(data.expires_in);
                return _context10.abrupt("return", {
                  data: session,
                  error: null
                });

              case 10:
                _context10.prev = 10;
                _context10.t0 = _context10["catch"](0);
                return _context10.abrupt("return", {
                  data: null,
                  error: _context10.t0
                });

              case 13:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 10]]);
      }));
    }
    /**
     * Sends an invite link to an email address.
     * @param email The email address of the user.
     * @param redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param data Optional user metadata
     */

  }, {
    key: "inviteUserByEmail",
    value: function inviteUserByEmail(email) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var headers, queryString, data;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                headers = Object.assign({}, this.headers);
                queryString = '';

                if (options.redirectTo) {
                  queryString += '?redirect_to=' + encodeURIComponent(options.redirectTo);
                }

                _context11.next = 6;
                return post(this.fetch, "".concat(this.url, "/invite").concat(queryString), {
                  email: email,
                  data: options.data
                }, {
                  headers: headers
                });

              case 6:
                data = _context11.sent;
                return _context11.abrupt("return", {
                  data: data,
                  error: null
                });

              case 10:
                _context11.prev = 10;
                _context11.t0 = _context11["catch"](0);
                return _context11.abrupt("return", {
                  data: null,
                  error: _context11.t0
                });

              case 13:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 10]]);
      }));
    }
    /**
     * Sends a reset request to an email address.
     * @param email The email address of the user.
     * @param redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param captchaToken Verification token received when the user completes the captcha on your site.
     */

  }, {
    key: "resetPasswordForEmail",
    value: function resetPasswordForEmail(email) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var headers, queryString, data;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                headers = Object.assign({}, this.headers);
                queryString = '';

                if (options.redirectTo) {
                  queryString += '?redirect_to=' + encodeURIComponent(options.redirectTo);
                }

                _context12.next = 6;
                return post(this.fetch, "".concat(this.url, "/recover").concat(queryString), {
                  email: email,
                  gotrue_meta_security: {
                    captcha_token: options.captchaToken
                  }
                }, {
                  headers: headers
                });

              case 6:
                data = _context12.sent;
                return _context12.abrupt("return", {
                  data: data,
                  error: null
                });

              case 10:
                _context12.prev = 10;
                _context12.t0 = _context12["catch"](0);
                return _context12.abrupt("return", {
                  data: null,
                  error: _context12.t0
                });

              case 13:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 10]]);
      }));
    }
    /**
     * Generates a new JWT.
     * @param refreshToken A valid refresh token that was returned on login.
     */

  }, {
    key: "refreshAccessToken",
    value: function refreshAccessToken(refreshToken) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var data, session;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                _context13.next = 3;
                return post(this.fetch, "".concat(this.url, "/token?grant_type=refresh_token"), {
                  refresh_token: refreshToken
                }, {
                  headers: this.headers
                });

              case 3:
                data = _context13.sent;
                session = Object.assign({}, data);
                if (session.expires_in) session.expires_at = expiresAt(data.expires_in);
                return _context13.abrupt("return", {
                  data: session,
                  error: null
                });

              case 9:
                _context13.prev = 9;
                _context13.t0 = _context13["catch"](0);
                return _context13.abrupt("return", {
                  data: null,
                  error: _context13.t0
                });

              case 12:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[0, 9]]);
      }));
    }
    /**
     * Set/delete the auth cookie based on the AuthChangeEvent.
     * Works for Next.js & Express (requires cookie-parser middleware).
     * @param req The request object.
     * @param res The response object.
     */

  }, {
    key: "setAuthCookie",
    value: function setAuthCookie(req, res) {
      var _this = this;

      if (req.method !== 'POST') {
        res.setHeader('Allow', 'POST');
        res.status(405).end('Method Not Allowed');
      }

      var _req$body = req.body,
          event = _req$body.event,
          session = _req$body.session;
      if (!event) throw new Error('Auth event missing!');

      if (event === 'SIGNED_IN') {
        if (!session) throw new Error('Auth session missing!');
        setCookies(req, res, [{
          key: 'access-token',
          value: session.access_token
        }, {
          key: 'refresh-token',
          value: session.refresh_token
        }].map(function (token) {
          var _a;

          return {
            name: "".concat(_this.cookieName(), "-").concat(token.key),
            value: token.value,
            domain: _this.cookieOptions.domain,
            maxAge: (_a = _this.cookieOptions.lifetime) !== null && _a !== void 0 ? _a : 0,
            path: _this.cookieOptions.path,
            sameSite: _this.cookieOptions.sameSite
          };
        }));
      }

      if (event === 'SIGNED_OUT') {
        setCookies(req, res, ['access-token', 'refresh-token'].map(function (key) {
          return {
            name: "".concat(_this.cookieName(), "-").concat(key),
            value: '',
            maxAge: -1
          };
        }));
      }

      res.status(200).json({});
    }
    /**
     * Deletes the Auth Cookies and redirects to the
     * @param req The request object.
     * @param res The response object.
     * @param options Optionally specify a `redirectTo` URL in the options.
     */

  }, {
    key: "deleteAuthCookie",
    value: function deleteAuthCookie(req, res, _ref4) {
      var _this2 = this;

      var _ref4$redirectTo = _ref4.redirectTo,
          redirectTo = _ref4$redirectTo === void 0 ? '/' : _ref4$redirectTo;
      setCookies(req, res, ['access-token', 'refresh-token'].map(function (key) {
        return {
          name: "".concat(_this2.cookieName(), "-").concat(key),
          value: '',
          maxAge: -1
        };
      }));
      return res.redirect(307, redirectTo);
    }
    /**
     * Helper method to generate the Auth Cookie string for you in case you can't use `setAuthCookie`.
     * @param req The request object.
     * @param res The response object.
     * @returns The Cookie string that needs to be set as the value for the `Set-Cookie` header.
     */

  }, {
    key: "getAuthCookieString",
    value: function getAuthCookieString(req, res) {
      var _this3 = this;

      if (req.method !== 'POST') {
        res.setHeader('Allow', 'POST');
        res.status(405).end('Method Not Allowed');
      }

      var _req$body2 = req.body,
          event = _req$body2.event,
          session = _req$body2.session;
      if (!event) throw new Error('Auth event missing!');

      if (event === 'SIGNED_IN') {
        if (!session) throw new Error('Auth session missing!');
        return getCookieString(req, res, [{
          key: 'access-token',
          value: session.access_token
        }, {
          key: 'refresh-token',
          value: session.refresh_token
        }].map(function (token) {
          var _a;

          return {
            name: "".concat(_this3.cookieName(), "-").concat(token.key),
            value: token.value,
            domain: _this3.cookieOptions.domain,
            maxAge: (_a = _this3.cookieOptions.lifetime) !== null && _a !== void 0 ? _a : 0,
            path: _this3.cookieOptions.path,
            sameSite: _this3.cookieOptions.sameSite
          };
        }));
      }

      if (event === 'SIGNED_OUT') {
        return getCookieString(req, res, ['access-token', 'refresh-token'].map(function (key) {
          return {
            name: "".concat(_this3.cookieName(), "-").concat(key),
            value: '',
            maxAge: -1
          };
        }));
      }

      return res.getHeader('Set-Cookie');
    }
    /**
     * Generates links to be sent via email or other.
     * @param type The link type ("signup" or "magiclink" or "recovery" or "invite").
     * @param email The user's email.
     * @param password User password. For signup only.
     * @param data Optional user metadata. For signup only.
     * @param redirectTo The link type ("signup" or "magiclink" or "recovery" or "invite").
     */

  }, {
    key: "generateLink",
    value: function generateLink(type, email) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var data;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                _context14.next = 3;
                return post(this.fetch, "".concat(this.url, "/admin/generate_link"), {
                  type: type,
                  email: email,
                  password: options.password,
                  data: options.data,
                  redirect_to: options.redirectTo
                }, {
                  headers: this.headers
                });

              case 3:
                data = _context14.sent;
                return _context14.abrupt("return", {
                  data: data,
                  error: null
                });

              case 7:
                _context14.prev = 7;
                _context14.t0 = _context14["catch"](0);
                return _context14.abrupt("return", {
                  data: null,
                  error: _context14.t0
                });

              case 10:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[0, 7]]);
      }));
    } // User Admin API

    /**
     * Creates a new user.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     *
     * @param attributes The data you want to create the user with.
     */

  }, {
    key: "createUser",
    value: function createUser(attributes) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var data;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                _context15.next = 3;
                return post(this.fetch, "".concat(this.url, "/admin/users"), attributes, {
                  headers: this.headers
                });

              case 3:
                data = _context15.sent;
                return _context15.abrupt("return", {
                  user: data,
                  data: data,
                  error: null
                });

              case 7:
                _context15.prev = 7;
                _context15.t0 = _context15["catch"](0);
                return _context15.abrupt("return", {
                  user: null,
                  data: null,
                  error: _context15.t0
                });

              case 10:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[0, 7]]);
      }));
    }
    /**
     * Get a list of users.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */

  }, {
    key: "listUsers",
    value: function listUsers() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var data;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                _context16.next = 3;
                return get(this.fetch, "".concat(this.url, "/admin/users"), {
                  headers: this.headers
                });

              case 3:
                data = _context16.sent;
                return _context16.abrupt("return", {
                  data: data.users,
                  error: null
                });

              case 7:
                _context16.prev = 7;
                _context16.t0 = _context16["catch"](0);
                return _context16.abrupt("return", {
                  data: null,
                  error: _context16.t0
                });

              case 10:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this, [[0, 7]]);
      }));
    }
    /**
     * Get user by id.
     *
     * @param uid The user's unique identifier
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */

  }, {
    key: "getUserById",
    value: function getUserById(uid) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var data;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                _context17.next = 3;
                return get(this.fetch, "".concat(this.url, "/admin/users/").concat(uid), {
                  headers: this.headers
                });

              case 3:
                data = _context17.sent;
                return _context17.abrupt("return", {
                  data: data,
                  error: null
                });

              case 7:
                _context17.prev = 7;
                _context17.t0 = _context17["catch"](0);
                return _context17.abrupt("return", {
                  data: null,
                  error: _context17.t0
                });

              case 10:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this, [[0, 7]]);
      }));
    }
    /**
     * Get user by reading the cookie from the request.
     * Works for Next.js & Express (requires cookie-parser middleware).
     */

  }, {
    key: "getUserByCookie",
    value: function getUserByCookie(req, res) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var _this4 = this;

        var access_token, refresh_token, _yield$this$getUser, user, getUserError, _yield$this$refreshAc, data, error;

        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;

                if (req.cookies) {
                  _context18.next = 3;
                  break;
                }

                throw new Error('Not able to parse cookies! When using Express make sure the cookie-parser middleware is in use!');

              case 3:
                access_token = req.cookies["".concat(this.cookieName(), "-access-token")];
                refresh_token = req.cookies["".concat(this.cookieName(), "-refresh-token")];

                if (access_token) {
                  _context18.next = 7;
                  break;
                }

                throw new Error('No cookie found!');

              case 7:
                _context18.next = 9;
                return this.getUser(access_token);

              case 9:
                _yield$this$getUser = _context18.sent;
                user = _yield$this$getUser.user;
                getUserError = _yield$this$getUser.error;

                if (!getUserError) {
                  _context18.next = 29;
                  break;
                }

                if (refresh_token) {
                  _context18.next = 15;
                  break;
                }

                throw new Error('No refresh_token cookie found!');

              case 15:
                if (res) {
                  _context18.next = 17;
                  break;
                }

                throw new Error('You need to pass the res object to automatically refresh the session!');

              case 17:
                _context18.next = 19;
                return this.refreshAccessToken(refresh_token);

              case 19:
                _yield$this$refreshAc = _context18.sent;
                data = _yield$this$refreshAc.data;
                error = _yield$this$refreshAc.error;

                if (!error) {
                  _context18.next = 26;
                  break;
                }

                throw error;

              case 26:
                if (!data) {
                  _context18.next = 29;
                  break;
                }

                setCookies(req, res, [{
                  key: 'access-token',
                  value: data.access_token
                }, {
                  key: 'refresh-token',
                  value: data.refresh_token
                }].map(function (token) {
                  var _a;

                  return {
                    name: "".concat(_this4.cookieName(), "-").concat(token.key),
                    value: token.value,
                    domain: _this4.cookieOptions.domain,
                    maxAge: (_a = _this4.cookieOptions.lifetime) !== null && _a !== void 0 ? _a : 0,
                    path: _this4.cookieOptions.path,
                    sameSite: _this4.cookieOptions.sameSite
                  };
                }));
                return _context18.abrupt("return", {
                  token: data.access_token,
                  user: data.user,
                  data: data.user,
                  error: null
                });

              case 29:
                return _context18.abrupt("return", {
                  token: access_token,
                  user: user,
                  data: user,
                  error: null
                });

              case 32:
                _context18.prev = 32;
                _context18.t0 = _context18["catch"](0);
                return _context18.abrupt("return", {
                  token: null,
                  user: null,
                  data: null,
                  error: _context18.t0
                });

              case 35:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this, [[0, 32]]);
      }));
    }
    /**
     * Updates the user data.
     *
     * @param attributes The data you want to update.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */

  }, {
    key: "updateUserById",
    value: function updateUserById(uid, attributes) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var data;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                this; //

                _context19.next = 4;
                return put(this.fetch, "".concat(this.url, "/admin/users/").concat(uid), attributes, {
                  headers: this.headers
                });

              case 4:
                data = _context19.sent;
                return _context19.abrupt("return", {
                  user: data,
                  data: data,
                  error: null
                });

              case 8:
                _context19.prev = 8;
                _context19.t0 = _context19["catch"](0);
                return _context19.abrupt("return", {
                  user: null,
                  data: null,
                  error: _context19.t0
                });

              case 11:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this, [[0, 8]]);
      }));
    }
    /**
     * Delete a user. Requires a `service_role` key.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     *
     * @param uid The user uid you want to remove.
     */

  }, {
    key: "deleteUser",
    value: function deleteUser(uid) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var data;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.prev = 0;
                _context20.next = 3;
                return remove(this.fetch, "".concat(this.url, "/admin/users/").concat(uid), {}, {
                  headers: this.headers
                });

              case 3:
                data = _context20.sent;
                return _context20.abrupt("return", {
                  user: data,
                  data: data,
                  error: null
                });

              case 7:
                _context20.prev = 7;
                _context20.t0 = _context20["catch"](0);
                return _context20.abrupt("return", {
                  user: null,
                  data: null,
                  error: _context20.t0
                });

              case 10:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this, [[0, 7]]);
      }));
    }
    /**
     * Gets the current user details.
     *
     * This method is called by the GoTrueClient `update` where
     * the jwt is set to this.currentSession.access_token
     * and therefore, acts like getting the currently authenticated user
     *
     * @param jwt A valid, logged-in JWT. Typically, the access_token for the currentSession
     */

  }, {
    key: "getUser",
    value: function getUser(jwt) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var data;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.prev = 0;
                _context21.next = 3;
                return get(this.fetch, "".concat(this.url, "/user"), {
                  headers: this._createRequestHeaders(jwt)
                });

              case 3:
                data = _context21.sent;
                return _context21.abrupt("return", {
                  user: data,
                  data: data,
                  error: null
                });

              case 7:
                _context21.prev = 7;
                _context21.t0 = _context21["catch"](0);
                return _context21.abrupt("return", {
                  user: null,
                  data: null,
                  error: _context21.t0
                });

              case 10:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this, [[0, 7]]);
      }));
    }
    /**
     * Updates the user data.
     * @param jwt A valid, logged-in JWT.
     * @param attributes The data you want to update.
     */

  }, {
    key: "updateUser",
    value: function updateUser(jwt, attributes) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var data;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.prev = 0;
                _context22.next = 3;
                return put(this.fetch, "".concat(this.url, "/user"), attributes, {
                  headers: this._createRequestHeaders(jwt)
                });

              case 3:
                data = _context22.sent;
                return _context22.abrupt("return", {
                  user: data,
                  data: data,
                  error: null
                });

              case 7:
                _context22.prev = 7;
                _context22.t0 = _context22["catch"](0);
                return _context22.abrupt("return", {
                  user: null,
                  data: null,
                  error: _context22.t0
                });

              case 10:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this, [[0, 7]]);
      }));
    }
  }]);

  return GoTrueApi;
}();

export { GoTrueApi as default };